<template>
  <div class="vipBox">
    <ul class="nav">
      <li
        v-for="(item, index) in typeBox"
        :key="index"
        :class="navIndex == index ? 'active' : ''"
        @click="getLclassVip(item.lclasscode, item.class, index)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="content">
      <div class="swiperBox">
        <swiper ref="mySwiper" :options="swiperOption" class="swiper-wrapper">
          <swiper-slide v-for="(item, index) in typeBox" :key="index">
            <ul class="vipList">
              <li
                v-for="(item1, index1) in showList(item)"
                :key="index1"
                @click="goPay(item1)"
              >
                <img :src="item1.image" />
              </li>
            </ul>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "vip",
  metaInfo: {
    title: "开通会员",
  },
  data() {
    return {
      noHeader: 0,
      typeBox: [
        { name: "音乐", class: "music", lclasscode: "615504302097563648" },
        { name: "美术", class: "art", lclasscode: "1000001" },
        {
          name: "书法/篆刻",
          class: "calligraphy",
          lclasscode: "681876991783206912",
        },
        { name: "舞蹈", class: "dance", lclasscode: "621272564823490560" },
        { name: "生活艺术", class: "other", lclasscode: "681890229321203712" },
      ],
      all: "",
      musicList: [],
      artList: [],
      calligraphyList: [],
      danceList: [],
      otherList: [],
      navIndex: 0,
      swiperOption: {
        onSlideChangeStart: function (swiper) {
          this.navIndex = swiper.activeIndex;
        }.bind(this),
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    this.login = localStorage.getItem("authorization") ? true : false;
    this.getVip();
    this.getLclassVip(this.typeBox[0].lclasscode, this.typeBox[0].class, 0);
  },
  methods: {
    showList(item) {
      return this[item.class + "List"];
    },
    getVip() {
      var obj = {
        pageNum: 1,
        pageSize: 1,
        productcategory: 1020,
      };
      this.$post("/iart-api-scm/api/scm/product/queryVIPlist", obj).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              var data = res.data && res.data.rows ? res.data.rows : [];
              this.all = data[0];
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getLclassVip(lclasscode, type, index) {
      this.navIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
      if (this[type + "List"].length > 0) {
        return false;
      }
      var obj = {
        pageNum: 1,
        pageSize: 100,
        lclasscode: lclasscode,
      };
      this.$post("/iart-api-scm/api/scm/product/queryVIPlist", obj).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              var data = res.data && res.data.rows ? res.data.rows : [];
              this[type + "List"] = data;
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    goPay(item) {
      if (!this.login) {
        if (typeof window.android != "undefined") {
          window.android.loginOut();
        } else if (typeof window.IARTSCHOOL != "undefined") {
          window.IARTSCHOOL.login();
        }
        return false;
      } else {
        if (typeof window.android != "undefined") {
          window.android.toBuyVip(
            JSON.stringify({ referencevalue: item.referencevalue })
          );
        } else if (typeof window.IARTSCHOOL != "undefined") {
          window.IARTSCHOOL.toBuyVip({
            referencevalue: item.referencevalue,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vipBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 100%;
  overflow: auto;
  // background:rgba(239, 236, 219, 1);
  // background: rgba(254, 254, 212, 1);
  background: rgba(242, 255, 216, 1);
  // background: #fff;
  display: flex;
  flex-direction: column;
  .nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background: rgba(207, 247, 160, 1);
    // background: rgba(231, 221, 194, 1);
      // background: linear-gradient(135deg, #d3f6f6 0%, #bfeff4 100%);
    // background: rgba(189, 223, 132, 1);
    li {
      font-size: 16px;
      line-height: 22px;
      padding: 14px 0;
      color: rgba(0, 0, 0, 1);
      position: relative;
    }
    li.active::before {
      content: " ";
      display: inline-block;
      width: 13px;
      height: 3px;
      background: rgba(0, 0, 0, 1);
      position: absolute;
      left: 50%;
      bottom: 7px;
      margin-left: -6.5px;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    .swiperBox {
      .vipList {
        margin-top: 24px;
        padding: 0 16px;
        li {
          width: 100%;
          margin-bottom: 24px;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>